import { Option } from 'Interfaces/FDPInterfaces/constrainedForecastBulkEdit';
import { filterInterface } from 'Interfaces/FDPInterfaces/unconstrainedForecastBulkEdit';
import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { factScreenServices } from 'services/factsScreenServices';
import { unconstrainedForecastService } from 'services/fdp/unconstrainedForecastService';
import { tmsScreenServices } from 'services/tmsScreenServices';
import { deepCopy } from 'utils/deepCopy';

export const useFilterSection = ({
  // setData,
  // pageNumber,
  filterpayload,
  handleApplyFilters,
  isDataLoading: _isDataLoading,
  areChangesToBeSaved,
}: // setFilterpayload,
// setIsDataLoading,
// setCopyData,
// setPageNumber,
{
  // setData: Dispatch<SetStateAction<[] | bulkEditDataInterface[]>>;
  // pageNumber: number;
  filterpayload: filterInterface;
  // setFilterpayload: Dispatch<SetStateAction<filterInterface>>;
  // setIsDataLoading: Dispatch<SetStateAction<boolean>>;
  // setCopyData: Dispatch<SetStateAction<[] | bulkEditDataInterface[]>>;
  // setPageNumber: Dispatch<SetStateAction<number>>;
  isDataLoading: boolean;
  areChangesToBeSaved: boolean;
  handleApplyFilters: (filterData: filterInterface) => void;
}) => {
  const RampingOptions: { label: string; value: boolean }[] = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];
  const StratCodeOptions: { label: string; value: string }[] = [
    { label: 'Model', value: 'model' },
    { label: 'Manual', value: 'manual' },
  ];
  const SellingCategoryOptions: { label: string; value: string }[] = [
    { label: 'Direct', value: 'Direct' },
    { label: 'Indirect', value: 'Indirect' },
  ];
  const ContractTypeOptions: { label: string; value: string }[] = [
    { label: 'MAS', value: 'MAS' },
    { label: 'NC', value: 'NC' },
  ];

  const [isAllMoleculesLoading, setIsAllMoleculesLoading] = useState<boolean>(true);
  const [isAllConceptLoading, setIsAllConceptLoading] = useState<boolean>(true);
  const [isAllSupplierNamesLoading, setIsAllSupplierNamesLoading] = useState<boolean>(true);
  const [allMolecules, setAllMolecules] = useState<string[]>([]);
  const [allConcepts, setAllConcepts] = useState<string[]>([]);
  const [allSupplierNames, setAllSupplierNames] = useState<string[]>([]);
  const [filteredMolecules, setFilteredMolecules] = useState<string[]>([]);
  const [filteredConcept, setFilteredConcept] = useState<string[]>([]);
  const [filteredSupplierNames, setFilteredSupplierNames] = useState<string[]>([]);
  const [filter, setFilter] = useState<filterInterface>({
    Ramping: '',
    Concept: '',
    MoleculeAndDosageForm: '',
    StrategyCode: '',
    SellingCategory: '',
    NDC11: '',
    ConceptSort: '',
    SupplierName: '',
    ContractType: '',
  });
  const [applyFilterConfirmationModalVisibility, setApplyFilterConfirmationModalVisibility] =
    useState<boolean>(false);

  const handleRestFilter = () => {
    setFilter({
      Ramping: '',
      Concept: '',
      MoleculeAndDosageForm: '',
      StrategyCode: '',
      SellingCategory: '',
      NDC11: '',
      ConceptSort: '',
      SupplierName: '',
      ContractType: '',
    });
  };

  const handlerFunctions = {
    handleFilterMolecules: async (e: { query: string }) => {
      const query = e.query.toLocaleLowerCase();
      const tempMolecules: string[] = [];

      for (const item of allMolecules) {
        if (item.toLocaleLowerCase().includes(query)) {
          tempMolecules.push(item);
        }
      }

      setFilteredMolecules(tempMolecules);
    },

    handleFilterConcepts: async (e: { query: string }) => {
      const query = e.query.toLocaleLowerCase();
      const tempConcepts: string[] = [];

      for (const item of allConcepts) {
        if (item.toLocaleLowerCase().includes(query)) {
          tempConcepts.push(item);
        }
      }

      setFilteredConcept(tempConcepts);
    },

    handleFilterSupplierNames: (e: { query: string }) => {
      const query = e.query.toLocaleLowerCase();
      setFilteredSupplierNames(
        allSupplierNames.filter(name => name.toLocaleLowerCase().includes(query))
      );
    },
  };

  const abortControllerRef = useRef<AbortController | null>(null);

  const getfilterOption = {
    getAllMolecules: async () => {
      try {
        setIsAllMoleculesLoading(true);
        const molecules = await factScreenServices.getAllMoleculeDetails();
        const temp = molecules.map(item => item.molecule_dose_form);
        setAllMolecules(temp);
      } catch (error) {
        console.log('Cannot fetch molecules: ', error);
        toast.error('Cannot fetch all the molecules');
      } finally {
        setIsAllMoleculesLoading(false);
      }
    },

    getAllConcepts: async () => {
      try {
        setIsAllConceptLoading(true);
        const concepts = await tmsScreenServices.getAllGSMSConceptForSalesPlan();
        const temp = concepts.map(item => item.concept);
        setAllConcepts(temp);
      } catch (error) {
        console.log('Cannot fetch all the concepts: ', error);
        toast.error('Cannot fetch all the concepts');
      } finally {
        setIsAllConceptLoading(false);
      }
    },

    getAllSupplierNames: async () => {
      try {
        setIsAllSupplierNamesLoading(true);
        const names = await unconstrainedForecastService.getSupplierNameSuggestions();
        setAllSupplierNames(names);
      } catch (error) {
        console.log('Cannot fetch supplier names: ', error);
        toast.error('Cannot fetch all the supplier names');
      } finally {
        setIsAllSupplierNamesLoading(false);
      }
    },

    fetchNDCSuggestions: async (inputValue: string): Promise<Option[]> => {
      // cancel any ongoing request if there is one
      if (abortControllerRef.current) {
        abortControllerRef.current.abort(); // Abort the previous requrest
      }

      // Create a new Abort controller for the new request
      const controller = new AbortController();
      abortControllerRef.current = controller;

      return new Promise(resolve => {
        setTimeout(async () => {
          try {
            const response = await unconstrainedForecastService.getNDC11Suggestions(
              inputValue,
              controller.signal
            );
            const suggestions: Option[] = [];

            for (const item of response) {
              suggestions.push({ label: item, value: item });
            }

            resolve(suggestions);
          } catch (error) {
            console.error('Error fetching the suggestions: ', error);
            resolve([]);
          }
        }, 500);
      });
    },
  };

  const setFilterValues = (field: keyof filterInterface, value: string) => {
    const filterCopy = deepCopy(filter);
    filterCopy[field] = value;
    setFilter(filterCopy);
  };

  const handleFilter = async () => {
    setApplyFilterConfirmationModalVisibility(false);
    if (JSON.stringify(filter) === JSON.stringify(filterpayload)) {
      return;
    }
    handleApplyFilters(filter);
  };

  const handleApplyFilterButtonClick = () => {
    if (areChangesToBeSaved) {
      setApplyFilterConfirmationModalVisibility(true);
    } else {
      handleFilter();
    }
  };

  const isFilterButtonDisabled = () => {
    if (JSON.stringify(filter) === JSON.stringify(filterpayload)) {
      return true;
    }
    return false;
  };

  const toggleApplyFilterConfirmationModalVisibility = () => {
    setApplyFilterConfirmationModalVisibility(!applyFilterConfirmationModalVisibility);
  };

  // Cleanup on component unmount (cancel any ongoing request)
  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  useEffect(() => {
    getfilterOption.getAllMolecules();
    getfilterOption.getAllConcepts();
    getfilterOption.getAllSupplierNames();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    RampingOptions,
    StratCodeOptions,
    SellingCategoryOptions,
    ContractTypeOptions,
    isAllMoleculesLoading,
    filterpayload,
    filteredMolecules,
    isAllConceptLoading,
    filteredConcept,
    isAllSupplierNamesLoading,
    filteredSupplierNames,
    filter,
    setFilter,
    setFilterValues,
    handleFilter,
    handlerFunctions,
    getfilterOption,
    handleRestFilter,
    handleApplyFilterButtonClick,
    isFilterButtonDisabled,
    applyFilterConfirmationModalVisibility,
    toggleApplyFilterConfirmationModalVisibility,
  };
};
